export default {
  app: {
    golf: {
      title: 'コース情報',
      hasEVChargingPoint: 'EV充電ポイント',
      hasCaddieService: 'キャディサービス',
      hasTrolley: 'トロリー',
      hasBuggy: 'バギー',
      hasClubRental: 'クラブレンタル',
      hasAcademy: 'アカデミー',
      hasMarshal: 'マーシャル',
      hasPGACertification: 'PGA認定',
      hasTrainingArea: '練習エリア',
      hasRestaurant: 'レストラン',
      hasHotel: 'ホテル',
      hasDogsOnCourse: 'コース内の犬',
      numberOfHoles: 'ホール数',
    },
  },
};
